var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca class=\"map-trigger\" ng-click=\"$ctrl.openModal()\"\u003ETérkép\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/applications/kalkulator/gazdalkodasikalkulator/talajtipus-terkep/talajtipus-terkep.pug
// module id = 266
// module chunks = 1